import React, { FC, useMemo } from 'react';
import { Item, ItemProps } from '@cld/item';
import { asStyledComponent } from '@cld/component-enhancer';
import { StylableComponentProps } from '@cld/common-definitions';
import { mergeCallbacks, useListSelection, useListStyle, useUniqueId } from '@cld/compound-components';
import { useRegisterChildData } from './childData';

export const ID_ATTRIBUTE_NAME = 'data-selectable-id';

export interface MenuItemProps extends ItemProps, StylableComponentProps {
  id?: string;
}

export const useMenuItemProps = ({ onClick, id: idProvided, ...rest }: MenuItemProps) => {
  const listStyle = useListStyle();
  const id = useUniqueId(idProvided);

  const childData = useMemo(() => ({ onClick }), [onClick]);
  useRegisterChildData(id, childData);

  const { onClick: onClickListSelection, ...selection } = useListSelection(id);

  const onClickCombined = mergeCallbacks(onClickListSelection, onClick);
  return { [ID_ATTRIBUTE_NAME]: id, ...listStyle, ...selection, isSelected: selection.isFocused, isFocused: false, onClick: onClickCombined, ...rest };
};

export const MenuItem = asStyledComponent<FC<Partial<MenuItemProps>>>(({ children, ...rest }) => {
  const listItemProps = useMenuItemProps(rest);

  return <Item {...listItemProps}>{children}</Item>;
});
